import ShUserAvatar from '@/components/Helpers/ShUserAvatar';
import ShButton from '@/components/Helpers/ShButton';

// @vue/component
export default {
  name: 'ConnectionAddNote',

  components: {
    ShButton,
    ShUserAvatar,
  },

  props: {
    connection: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      note: null,
    };
  },

  computed: {
    userAvatar() {
      return this.$store.getters['authorization/user'].avatar;
    },
    isLoading() {
      return this.$store.getters['app/pendingStoreActions'].includes([
        'connections/notes/create',
      ]);
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.note.$el.getElementsByTagName('input')[0].focus();
    });
  },

  methods: {
    handleCloseModal() {
      this.$emit('closeModal');
    },
    async handleAddNote() {
      if (this.note) {
        const params = {
          note: this.note,
          connection_id: this.connection.id,
        };
        this.note = null;
        await this.$store.dispatch('connections/notes/create', params);
        this.$store.dispatch('connections/notes/getList', this.connection.id);
        this.$notify.success({
          title: 'Dodanie notatki',
          message: 'Dodano nową notatkę',
          customClass: 'callmeweb-notification',
        });
        this.$store.commit('connections/INCREASE_NOTES_COUNT_IN_CONNECTION_RECORD', { connectionId: this.connection.id });
      }
    },
  },
};
